<template>
	<div :class="['phone_dialog', { collapsed: isCollapsed }]" id="phone_dialog">
		<div class="phone_dialog_title">
			<div class="left">
				<div class="in-call-status icon">
					<img style="width: 21px;height: 21px;" src="../../assets/img/Online.png" slot="reference" />
				</div> 
				<div class="num-text">内線番号: </div>
				<div class="num text-margin-left">{{ telNum }}</div>
				<div class="user-name text-margin-left">
					<span class="ellipsis">{{ userName }}</span>
				</div>
			</div>
			<div class="title_menu">
			<div class="title_btn" @click="showCallFun(1)">
				<font-awesome-icon :icon="['fas', 'phone']" />
			</div>
				<div class="title_btn fold_btn" @click="collapsePhone">
					<i :class="isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
				</div>
				<div
					class="title_btn"
					@click="closePhone"
				>
					<font-awesome-icon :icon="['fas', 'xmark']" />
				</div>
			</div>
		</div>
		<div class="phone_dialog_content">
			<!-- on call html component start -->
			<div class="curLineCollapse" id="curLineCollapse">
			<div v-if="false" class="on_call_box monitoring-ended-box">
				<div class="monitoring-ended-title">
					<span class="call-title">{{ callEndedMessage }}</span>
				</div>
			</div>
			<el-collapse
				v-else
				v-model="selectedCurLine"
				accordion
				@change="changeCurLine"
			>
				<el-collapse-item v-for="(c, index) in allCallsList" :key="index" :name="c.LineNumber" class="on_call_box">
						<template slot="title">
							<!-- 監視通話（555開頭）显示モニタリング中 -->
							<template v-if="isMonitoringCall(c.LineNumber)">
								<span class="call-title">モニタリング中</span>
								<span class="call-time" v-if="monitoringCallTime">通話時間 {{ monitoringCallTime }}</span>
							</template>
							<!-- 普通通話显示正常状态 -->
							<template v-else>
								<span class="call-title">{{ c.SipSession.isOnHold ? "通話保留中" : (c.SipSession.data.started ? "通話中" : "呼び出し中") }}</span>
								<span> ({{ computeFullName(c.lastname, c.firstname) }})</span>
							</template>
						</template>
						<!-- 監視通話的UI -->
						<template v-if="isMonitoringCall(c.LineNumber)">
							<div class="on_call_info">
								<div class="user_info user_info_margin-right">
									<div class="avatar">
										<el-avatar :size="70" src="">
											<img :src="c.logo_url ? c.logo_url : defaultAvatar" alt="" srcset="">
										</el-avatar>
									</div>
									<div class="name">
										<div>{{ computeFullName(c.lastname, c.firstname) }}</div>
									</div>
								</div>
								<div class ="call_info">
									<div class = "address">
										{{c.address}}
									</div>
									<div class="call_num">
										{{ c.LineNumber.substr(3)}}
									</div>
									<div class="email">
										{{c.email}}
									</div>
								</div>
							</div>
							<div class ="on_call_info operator_call_info">
								<div class="call_info">
									<div class="call_num">{{`内線番号: ${$store.state.phone.monitorInfo.operatorNum}`}}</div>
									<div class="email">{{$store.state.phone.monitorInfo.operatorEmail}}</div>
								</div>
								<div class="user_info">
									<div class="avatar">
										<el-avatar :size="70" src="">
											<img :src="$store.state.phone.monitorInfo.operatorLogo" alt="" srcset="">
										</el-avatar>
									</div>
									<div class="name">
										<div>{{$store.state.phone.monitorInfo.operatorName}}</div>
									</div>
								</div>
							</div>
						</template>
						<!-- 普通通話的UI -->
						<template v-else>
							<div class="on_call_info">
								<div class="user_info user_info_margin-right">
									<div class="avatar">
										<el-avatar :size="70" src="">
											<img :src="c.logo_url ? c.logo_url : defaultAvatar" alt="" srcset="">
										</el-avatar>
									</div>
									<div class="name">
										<div>{{ computeFullName(c.lastname, c.firstname) }}</div>
										<div
											class="t_num"
											v-if="
												c.SipSession.incomingInviteRequest &&
													c.SipSession.incomingInviteRequest.message.headers
														.Tnumber &&
													c.SipSession.incomingInviteRequest.message.headers
														.Tnumber.length &&
													c.SipSession.incomingInviteRequest.message.headers
														.Tnumber[0].raw
											"
										>
											{{ c.LineNumber }}から転送
										</div>
									</div>
								</div>
								<div class ="call_info">
									<div class="call_num">
										{{ c.LineNumber }}
									</div>
									<div class="call_time" v-if="c.SipSession.data.callTime">{{ c.SipSession.data.callTime }}</div>
									<div class="email">
										{{c.email}}
									</div>
								</div>
							</div>
						</template>
						<div class="on_call_btns">
							<div
								:class="{
									call_btn: true,
									cancel: btn.key == 'cancel',
									green_background: ['transfer','addCall','startCall'].indexOf(btn.key)>-1,
									ac: checkBtnAct(btn.key, c),
									disabled: checkBtnDisabled(btn,c),
								}"
								v-for="btn in btnList"
								:key="btn.key"
							>
								<div
									:class="{
										btn_item: true,
										disabled:checkBtnDisabled(btn,c),
									}"
									@click="clickCallBtn(btn.key, c)"
									:disabled="checkBtnDisabled(btn,c)"
								>
									<!-- ==========================================
									     修正日時: 2026-01-26
									     修正内容: 全ボタンをfont-awesome-iconで統一
									               - keyboard/addCallのVueSvgIcon分岐を削除し、callBtns.jsでFontAwesome指定に統一
									     ========================================== -->
									<!-- <div class="icon">
										<font-awesome-icon
											:icon="
												checkBtnAct(btn.key, c) && btn.actIcon ? btn.actIcon : btn.icon
											"
										/>
									</div> -->
									<!---=============================================
									   update the transfer button icon as the font-awesome-icon is not available
									   =============================================== -->
									<div class="icon">
										<icon
											:name="
												checkBtnAct(btn.key, c) && btn.actIcon ? btn.actIcon : btn.icon
											"
										></icon>
									</div>
									<div class="button-label">
										{{
											checkBtnAct(btn.key, c) && btn.actLabel
												? btn.actLabel
												: btn.label
										}}
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
			<!-- on call html component end -->
			<!-- in bound calls component start -->
			<div class="calls_box" v-if="callsList.length > 0" id="inbound">
				<Inbound
					:callsList="callsList"
					:lang="sipLang"
					@updateCallNum="updateCallNum"
				></Inbound>
			</div>
			<!-- in bound calls component end -->
			<!-- transfer call component start -->
			<div
				class="transfer_box"
				v-if="
					curLine &&
						curLine.SipSession.data.transfer &&
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'progress'
						).length
				"
			>
				<Transfer
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'progress'
						)
					"
					type="1"
					@transferFun="transferFun"
				></Transfer>
			</div>
			<!-- transfer call component end -->
			<!-- transfer call in progress component start -->
			<div
				class="transfer_box"
				v-if="
					curLine &&
						curLine.SipSession.data.transfer &&
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'accepted' && d.accept.complete == null
						).length
				"
			>
				<Transfer
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'accepted' && d.accept.complete == null
						)
					"
					type="0"
					@transferFun="transferFun"
				></Transfer>
			</div>
			<!-- transfer call in progress component end -->
			<!-- conference call component start -->
			<div
				class="conference_box"
				v-if="
					curLine &&
						curLine.SipSession.data.confcalls &&
						curLine.SipSession.data.confcalls.filter(
							(d) => d.disposition == 'progress'
						).length
				"
			>
				<Conference
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.confcalls.filter(
							(d) => d.disposition == 'progress'
						)
					"
					type="1"
					@conferFun="conferFun"
				></Conference>
			</div>
			<!-- conference call component end -->
			<!-- conference call in progress component start -->
			<div
				class="conference_box"
				v-if="
					curLine &&
						curLine.SipSession.data.confcalls &&
						curLine.SipSession.data.confcalls.filter(
							(d) =>
								d.disposition == 'accepted' &&
								d.accept.complete == null &&
								d.accept.disposition != 'bye'
						).length
				"
			>
				<Conference
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.confcalls.filter(
							(d) =>
								d.disposition == 'accepted' &&
								d.accept.complete == null &&
								d.accept.disposition != 'bye'
						)
					"
					type="0"
					@conferFun="conferFun"
				></Conference>
			</div>
			<!-- conference call in progress component end -->
						<!-- search call no. input component start -->
			<el-input
				placeholder=""
				prefix-icon="el-icon-search"
				v-model.trim="searchText"
				size="small"
				clearable
				v-if="!showCall && !showSetting"
				@input="searchContacts" 
				class="input-search"
			>
			</el-input>
			<!-- search call no. input component end -->
			<!-- call history component start -->
			<div :class="curLine ? 'buddies_list cl' : 'buddies_list'" v-if="!showCall && !showSetting">
				<el-tabs v-model="activeName" stretch>
					<el-tab-pane label="外線連絡先" name="ExternalContacts" v-if="false">
						<Contacts ref="externalContactRef" :searchText="searchText" @createCall="createCall" type="external" :active="activeName == 'ExternalContacts' && showPhone"/>
					</el-tab-pane>
					<el-tab-pane label="内線連絡先" name="InternalContacts">
						<Contacts ref="internalContactRef" :searchText="searchText" @createCall="createCall" type="internal" :active="activeName == 'InternalContacts' && showPhone"/>
					</el-tab-pane>
					<el-tab-pane label="通話履歴" name="Recent"
						><BuddiesList
							:searchText="searchText"
							:BuddiesList="$store.state.phone.buddiesList"
							@showDetail="showBuddieDetail"
						></BuddiesList
					></el-tab-pane>
				</el-tabs>
			</div>
			<!-- call history component end -->
			<!-- buddie detail component start -->
			<div class="buddie_box" v-if="showBuddieDtl">
				<BuddieDetail
					:buddieDtl="buddieDtl"
					:user="showBuddieDetailUser"
					@closeBuddieDetail="closeBuddieDetail"
					@createCall="createCall"
				></BuddieDetail>
			</div>
			<!-- buddie detail component end -->
			<!-- call phone component start -->
			<div class="call_box" v-if="showCall">
				<Keyboards
				  ref="keyboardsRef"
					@createCall="createCall"
					:showCallBtn="showCallBtn"
					@sendDTMF="sendDTMF"
					@callTransfer="callTransfer"
					@addCall="createConference"
					:callStatus="callStatus"
				></Keyboards>
			</div>
			<!-- call phone component end -->
			<!-- phone setting component start --> 
			<div class="phone-setting" v-if="showSetting">
				<Settings></Settings>
			</div>	
			<!-- phone setting component end --> 
		</div>
	</div>
</template>

<script>
import Keyboards from "@/components/phone/Keyboards.vue";
import { btnList } from "./callBtns";
import Inbound from "@/components/phone/Inbound.vue";
import BuddiesList from "@/components/phone/BuddiesList.vue";
import BuddieDetail from "@/components/phone/BuddieDetail.vue";
import Transfer from "./Transfer.vue";
import Conference from "./Conference.vue";
import Contacts from "./Contacts.vue";
import Settings from "./Settings.vue";
import default_photo from '@/assets/img/user_logo.png'
import _ from 'lodash';
import api from "@/api";

export default {
	name: "phone",
	components: {
		Keyboards,
		Inbound,
		BuddiesList,
		BuddieDetail,
		Transfer,
		Conference,
		Contacts,
		Settings,
	},
	computed: {
		telNum() {
			// DashboardではsysInitがないため、sessionStorageから取得
			// if (this.$store.state.sysInit && this.$store.state.sysInit.tel_num) {
			// 	return this.$store.state.sysInit.tel_num;
			// }
			// return sessionStorage.getItem('tel_num') || '';
			return this.$store.state.sysInit.tel_num
		},
		userName() {
			// DashboardではsysInitがないため、sessionStorageから取得
			// if (this.$store.state.sysInit && this.$store.state.sysInit.user_name) {
			// 	return this.$store.state.sysInit.user_name;
			// }
			// return sessionStorage.getItem('user_name') || '';
			return this.$store.state.sysInit.user_name
		},
		callsList() {
			return this.$store.state.phone.lineList.filter(
				(line) => line.SipSession.data.calldirection == "inbound" && !line.SipSession.data.started
			);
		},
		allCallsList() {
			return this.$store.state.phone.lineList.filter(e => (e.SipSession.data.calldirection == "inbound" && e.SipSession.data.started) || e.SipSession.data.calldirection == "outbound" ).map(e => ({ ...e, ...this.$store.state.phone.callList.find(d => d.telnum == e.LineNumber) }))
		},
		curLine() {
			return this.$store.state.phone.lineList.find(
				(line) => line.LineNumber == this.$store.state.phone.currentCallerNum
			);
		},
		buddieDtl() {
			return this.curBuddieUid
				? JSON.parse(localStorage.getItem(`${this.curBuddieUid}-stream`))
				: {};
		},
		sipLang() {
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: VueI18nを使用して言語テキストを取得
			//           - phone.jsの独自言語ロジックをVueI18nに統一
			//           - this.$i18n.messages['ja']を優先、フォールバックでgetLangText()
			// ==========================================
			// VueI18nが利用可能な場合はVueI18nを使用
			if (this.$i18n && this.$i18n.messages && this.$i18n.messages['ja']) {
				return this.$i18n.messages['ja'];
			}
			// フォールバック: phone.jsのgetLangText()を使用（後方互換性）
			return this.$SIP && this.$SIP.getLangText ? this.$SIP.getLangText() : {};
		},
		showPhone() {
			return this.$store.state.phone.showPhone;
		},
		defaultAvatar() {
			return default_photo;
		},	
		showCallEnded() {
			return this.monitoringEndedFlag || this.normalCallEndedFlag;
		},
		callEndedMessage() {
			if (this.monitoringEndedFlag) {
				return 'モニタリングが終了しました';
			}
			if (this.normalCallEndedFlag) {
				return '通話が終了しました';
			}
			return '';
		},
		// ==========================================
		// 修正日時: 2026-05-13
		// 修正内容: モニタリング中の通話時間を表示
		//           - text-monitor drawerと同様にtelRealTimeTableDataから通話時間を取得
		//           - monitoringDialNumから555プレフィックスを除去してマッチング
		// ==========================================
		monitoringCallTime() {
			// monitoringDialNum、currentCallerNum、allCallsListから555プレフィックス番号を取得
			let dialNum = this.monitoringDialNum;
			if (!dialNum) {
				dialNum = this.$store.state.phone.currentCallerNum;
			}
			if (!dialNum || !String(dialNum).startsWith('555')) {
				// allCallsListから555プレフィックスの通話を探す
				const monCall = this.allCallsList.find(c => c && c.LineNumber && String(c.LineNumber).startsWith('555'));
				if (monCall) {
					dialNum = monCall.LineNumber;
				}
			}
			if (!dialNum || !String(dialNum).startsWith('555') || !this.$root.telRealTimeTableData) {
				return '';
			}
			const targetNum = String(dialNum).substring(3);
			const telRow = this.$root.telRealTimeTableData.find(
				(row) => row && (row.callerNumber === targetNum || row.queueNum === targetNum)
			);
			return telRow && telRow.time ? telRow.time : '';
		},
	},
	watch: {
		curLine(newVal) {
			if (!newVal)
				(this.callNum = ""),
					this.$store.dispatch("phone/setOnCallInfo", ""),
					this.$store.commit("phone/setCurrentCallerNum", "");
			if (
				this.curLine &&
				this.curLine.SipSession.data.transfer &&
				this.curLine.SipSession.data.transfer.filter(
					(d) => d.disposition == "accepted" && d.accept.complete == null
				).length
			) {
				this.transferFun(0, true)
			}
		},
		"$store.state.phone.currentCallerNum": function(currentCallerNum) {
			if (currentCallerNum) {
				this.callNum = currentCallerNum;
				this.selectedCurLine = currentCallerNum;

				// 新しい通話開始時は終了表示状態をリセット
				this.normalCallEndedFlag = false;

				// モニタリング（555...）開始時は終了表示状態をリセット
				if (String(currentCallerNum).startsWith('555')) {
					this.monitoringDialNum = currentCallerNum;
					this.monitoringEndedFlag = false;
				} else {
					this.monitoringDialNum = '';
					this.monitoringEndedFlag = false;
				}
			} else {
				// currentCallerNum が空になっても、monitoringDialNum は lineList ウォッチャーが
				// 終了判定するまで保持する（タイミングズレ防止）
			}
		},
		"$store.state.phone.lineList": {
			handler: function(lineList, oldLineList) {
				// モニタリング通話が終了した場合の処理
				if (this.monitoringDialNum) {
					const stillInCall = (lineList || []).some(
						(line) => line && line.LineNumber === this.monitoringDialNum
					);
					if (!stillInCall) {
						this.monitoringDialNum = '';
						this.monitoringEndedFlag = true;
						this.normalCallEndedFlag = false;
						this.$message.success('モニタリングが終了しました');
					}
				}
				// 普通通話が終了した場合の処理
				// lastNormalCallNum を使って、普通通話が消えたことを検出
				if (this.lastNormalCallNum && !this.monitoringEndedFlag) {
					const stillExists = (lineList || []).some(
						(line) => line && line.LineNumber === this.lastNormalCallNum
					);
					if (!stillExists) {
						this.normalCallEndedFlag = true;
						this.lastNormalCallNum = '';
						this.$message.success('通話が終了しました');
					}
				}
				// 現在の普通通話番号を記録
				const normalCalls = (lineList || []).filter(
					line => line && line.LineNumber && !String(line.LineNumber).startsWith('555') && line.SipSession && line.SipSession.data && line.SipSession.data.started
				);
				if (normalCalls.length > 0) {
					this.lastNormalCallNum = normalCalls[normalCalls.length - 1].LineNumber;
				}
			},
			deep: true
		},
		"$store.state.phone.autoStartMonitoringCall": function(autoStart) {
			if (autoStart && this.$store.state.phone.currentCallerNum) {
				// モニタリング用の自動通話開始
				const dialNum = this.$store.state.phone.currentCallerNum;
				if (dialNum && dialNum.startsWith('555')) {
					// 少し待ってから通話を開始（ソフトフォンの表示を待つ）
					setTimeout(() => {
						this.createCall(dialNum);
						// フラグをリセット
						this.$store.commit('phone/setAutoStartMonitoringCall', false);
					}, 300);
				} else {
					// フラグをリセット（555で始まらない場合は通常の通話）
					this.$store.commit('phone/setAutoStartMonitoringCall', false);
				}
			}
		},
		"$store.state.phone.showPhone":function(showPhone){
			if(!showPhone){
				this.isCollapsed = false
			}
		},
	},
	data() {
		return {
			searchText: "",
			activeName: "InternalContacts",
			showCall: false,
			showCallBtn: true,
			callNum: "",
			btnList: [],
			actBtnList: [],
			showBuddieDtl: false,
			curBuddieUid: "",
			callStatus: false,
			selectedCurLine: 0,
			showBuddieDetailUser: {},
			callsObj: {},
			multiCallFlag: false,
			showSetting:false,
			isCollapsed: false,
			monitoringDialNum: '',
			monitoringEndedFlag: false,
			normalCallEndedFlag: false,
			lastNormalCallNum: '',
		};
	},
	created() {
		if (this.$store.state.phone.currentCallerNum)
			this.callNum = this.$store.state.phone.currentCallerNum;
		// $SIPが初期化されている場合のみbtnListを設定
		if (this.$SIP && this.$SIP.getLangText) {
			this.btnList = btnList(this.sipLang);
		} else {
			// $SIPが初期化されていない場合は空のオブジェクトを使用
			this.btnList = btnList({});
		}
		this.$store.dispatch("sysInit/init");
		
		// ==========================================
		// 修正日時: 2026-01-23
		// 修正内容: ログインユーザー情報を取得してsessionStorageに保存
		//           - 内線番号（tel_num）とユーザー名（user_name）をsessionStorageに保存
		//           - 既にsessionStorageに値がある場合はスキップ（重複取得を避ける）
		// ==========================================
		// sessionStorageにtel_numがない場合のみAPIを呼び出す
		// if (!sessionStorage.getItem('tel_num')) {
		// 	api.getUserInfo().then((res) => {
		// 		if (res && res.data && res.data.user) {
		// 			const user = res.data.user;
		// 			// 内線番号をsessionStorageに保存
		// 			if (user.tel_num) {
		// 				sessionStorage.setItem('tel_num', user.tel_num);
		// 			}
		// 			// ユーザー名をsessionStorageに保存
		// 			if (user.name) {
		// 				sessionStorage.setItem('user_name', user.name);
		// 			}
		// 		}
		// 	}).catch((err) => {
		// 		console.error('Failed to get user info:', err);
		// 	});
		// }
	},
	mounted() {},
	methods: {
		// 判断是否为监听通话（555开头）
		isMonitoringCall(lineNumber) {
			return lineNumber && String(lineNumber).startsWith('555');
		},
		computeFullName(lastname, firstname) {
			if (this.$utils && this.$utils.computeFullName) {
				return this.$utils.computeFullName(lastname, firstname);
			}
			return (lastname || '') + (firstname || '');
		},
		asteriskHeaderArray2Json(raw) {
			if (this.$utils && this.$utils.asteriskHeaderArray2Json) {
				return this.$utils.asteriskHeaderArray2Json(raw);
			}
			try {
				return JSON.parse(raw);
			} catch(e) {
				return { tnum: '', relatedIssueId: '' };
			}
		},
		changeCurLine(activeNames) {
			if(activeNames){
				this.$store.dispatch("phone/setOnCallInfo", activeNames);
				this.$store.commit("phone/setCurrentCallerNum", activeNames);
			}
		},
		showSettings(){
			this.showCall = false
			this.showSetting = !this.showSetting
		},
		showCallFun(flag) {
			if (this.isCollapsed) {
				this.isCollapsed = false;
				this.$emit('collapse-change', false);
				return;
			}
			this.showSetting = false;
			this.showCallBtn = flag;
			if(this.curLine && this.curLine.SipSession.isOnHold && this.curLine.SipSession.transferHold){
				flag = 2;
			}
			
			this.callStatus = false;
			let inbound = this.$store.state.phone.lineList.filter((line) => {
				return line.SipSession.data.calldirection == "inbound" && line.SipSession.data.started
			});
			if(inbound.length > 0){
				this.callStatus = true;
			}

			this.showCall = !this.showCall;
		},
		collapsePhone() {
			this.isCollapsed = !this.isCollapsed;
			this.$emit('collapse-change', this.isCollapsed);
		},
		closePhone() {
			this.isCollapsed = false;
			this.$emit('collapse-change', false);

			// モニタリング中（555...）の通話があれば切断
			const lineList = this.$store.state.phone.lineList || [];
			const toEnd = new Set();
			lineList.forEach((line) => {
				if (line && line.LineNumber && String(line.LineNumber).startsWith('555')) {
					toEnd.add(line.LineNumber);
				}
			});
			const mon = this.monitoringDialNum;
			if (mon && String(mon).startsWith('555')) {
				toEnd.add(mon);
			}
			const cc = this.$store.state.phone.currentCallerNum;
			if (cc && String(cc).startsWith('555')) {
				toEnd.add(cc);
			}

			if (toEnd.size && this.$SIP && typeof this.$SIP.endSession === 'function') {
				toEnd.forEach((dialNum) => {
					try {
						this.$SIP.endSession(dialNum);
					} catch (e) {
						console.error('closePhone endSession monitoring', dialNum, e);
					}
				});
				this.monitoringDialNum = '';
				this.monitoringEndedFlag = false;
				this.$store.state.startMonitoring = false;
				// モニタリング終了メッセージを表示
				this.$message.success('モニタリングが終了しました');
			}

			this.$store.dispatch('phone/setShowPhone', false);
		},
		checkBtnAct(key, c) {
			switch (key) {
				case "mute":
					return c.SipSession.data.ismute;
				case "hold":
					return c.SipSession.isOnHold || c.SipSession.isPlayHoldMusic;
				case "transfer":
					return (
						c.SipSession.isOnHold &&
						c.SipSession.transferHold
					);
				case "addCall":
					return (
						c.SipSession.isOnHold &&
						c.SipSession.conferenceHold
					);
				default:
					return false;
			}
		},
    checkBtnDisabled(btn,c){
      // During monitoring calls, disable every button except hang-up ("cancel"),
      // because monitoring is listen-only and other actions are meaningless / cause errors.
      if (this.isMonitoringCall(c.LineNumber) && btn.key !== "cancel") {
        return true;
      }
      switch (btn.key) {
        case "hold": return (c.SipSession.isPlayHoldMusic || c.SipSession.isPlayUnHoldMusic);
				case "startCall": return !this.showCall
        default:
					return btn.disabled;
      }
    },
		createCall(callNum) {
			this.$SIP.DialByLine("audio", null, callNum);
			this.callNum = callNum;
			this.$store.commit("phone/setCurrentCallerNum", this.callNum);
			this.showCall = false;
			this.onCall = true;
			this.selectedCurLine = callNum;
			
			// ==========================================
			// 修正日時: 2026-01-23
			// 修正内容: モニタリング時の自動ミュート処理を削除
			//           - モニタリングは「聞くだけ」の機能のため、ミュートは不要
			//           - 自動ミュート処理がエラーを引き起こしていたため削除
			//           - 必要に応じてユーザーが手動でミュートボタンを押すことができる
			// ==========================================
		},
		clickCallBtn(key, c) {
			this.callNum = c.LineNumber;
			switch (key) {
				case "mute":
					c.SipSession.data.ismute
						? this.$SIP.UnmuteSession(this.callNum)
						: this.$SIP.MuteSession(this.callNum);
					break;
				case "keyboard":
					this.showCallFun(0);
					break;
				case "hold":
					if(c.SipSession.isOnHold){ // unhold
            c.SipSession.isPlayUnHoldMusic = true;
						const unholdList = this.allCallsList.filter(e => !e.SipSession.isOnHold && e.LineNumber != this.callNum && e.SipSession.data.started)
						if(this.allCallsList.length > 1 && this.allCallsList.length == unholdList.length + 1){
							unholdList.forEach(call => {
								this.$SIP.holdWithPlaySound(this.callNum);
							});
						}
						this.$SIP.unholdSession(this.callNum)
					} else { // hold 
            c.SipSession.isPlayHoldMusic = true;
						this.$SIP.holdWithPlaySound(this.callNum);
					}
					break;
				case "transfer":
					if (
						c.SipSession.isOnHold &&
						c.SipSession.transferHold
					) {
						this.$SIP.CancelTransferSession(this.callNum);
					} else {
						this.$SIP.StartTransferSession(this.callNum);
						this.showCallFun(2);
					}
					break;
				case "addCall":
					if (
						c.SipSession.isOnHold &&
						c.SipSession.conferenceHold
					) {
						this.$SIP.CancelTransferSession(this.callNum);
					} else {
						this.$SIP.StartConferenceCall(this.callNum);
						this.showCallFun(3);
					}
					this.$SIP.StartConferenceCall(this.callNum);
					console.log(c);
					break;
				case "cancel":
					c.SipSession.data.started
						? this.$SIP.endSession(this.callNum)
						: this.$SIP.cancelSession(this.callNum);
						
					this.onCall = false;
					this.callNum = "";
					break;
				case"setting":
					this.showSettings();
				  break;
				case"startCall":
				  this.startCallFn();
					break;
			}
		},
		updateCallNum(callNum) {
			this.callNum = callNum;
			this.selectedCurLine = callNum;
		},
		showBuddieDetail(buddie, user) {
			this.curBuddieUid = buddie.identity;
			this.showBuddieDtl = true;
			this.showBuddieDetailUser = user;
		},
		closeBuddieDetail() {
			this.curBuddieUid = "";
			this.showBuddieDtl = false;
		},
		sendDTMF(num) {
			this.$SIP.sendDTMF(this.callNum, num);
		},
		callTransfer(flag, num) {
			if (flag) {
				this.$SIP.BlindTransfer(this.callNum, num);
			} else {
				this.$SIP.AttendedTransfer(this.callNum, num);
			}
			this.showCall = false;
		},
		transferFun(type, flag) {
			if (type == 0) {
				flag
					? this.$SIP.transferOnComplete(this.callNum)
					: this.$SIP.transferOnTerminate(this.callNum);
			} else {
				this.$SIP.transferOnCancel(this.callNum);
			}
		},
		createConference(num) {
			this.$SIP.ConferenceDial(this.callNum, num);
			this.showCall = false;
		},
		conferFun(type, flag) {
			if (type == 0) {
				flag
					? this.$SIP.conferenceOnComplete(this.callNum)
					: this.$SIP.conferenceOnTerminate(this.callNum);
			} else {
				this.$SIP.conferenceOnCancel(this.callNum);
			}
		},
		startCallFn(){
			console.log('phone vue... startCallFn')
			this.$refs.keyboardsRef.startCallFn()
		},
		searchContacts: _.debounce(function () { 
			if(this.$refs.externalContactRef) {
				this.$refs.externalContactRef.searchContacts()
			}
			if(this.$refs.internalContactRef) {
				this.$refs.internalContactRef.searchContacts()
			}
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.call-title{
	padding-left: 5px;
	font-size: 14px;
}
.call-time{
	margin-left: 10px;
	font-size: 14px;
}
.phone_dialog {
	padding: 15px 10px;
	height: 100%;
	overflow-y: hidden;
	&.collapsed {
		height: auto;
		padding-bottom: 0;
		.phone_dialog_title {
			margin-bottom: 0;
		}
		.phone_dialog_content {
			max-height: 0;
			height: 0;
			opacity: 0;
			overflow: hidden;
			margin-top: 0;
			padding-top: 0;
			padding-bottom: 0;
			border: 0;
			pointer-events: none;
		}
	}
}
// title
.phone_dialog_title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	line-height: 24px;
	margin-bottom: 10px;
	.icon {
		width: 22px;
		height: 22px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
	}
	.title_menu,
	.left {
		display: flex;
		align-items: center;
	}
	.left {
		.icon {
			margin-right: 10px;
		}
	}
	.title_menu {
		// 右端に張り付くため、少し内側へ寄せる
		margin-right: 8px;
		.title_btn + .title_btn {
			margin-left: 15px;
		}
		.title_btn {
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.fold_btn {
			font-size: 14px;
			[class*='el-icon-'] {
				font-weight: 600;
			}
		}
	}
	.text-margin-left{
		margin-left: 8px;
	}
	.ellipsis{
		display: inline-block;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
	}
}

// phone_dialog_content
.phone_dialog_content {
	height: calc(100% - 30px);
	max-height: calc(100% - 30px);
	position: relative;
	overflow-y: auto;
	opacity: 1;
	transition: max-height 0.22s ease, opacity 0.18s ease;
	.buddie_box {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 3;
		height: 100%;
		width: 100%;
		background: #fff;
	}
	.call_box {
		z-index: 4;
		width: 100%;
		background: #fff;
	}
	.on_call_box {
		background: #eff5f8;
		margin: 5px;
		// margin-bottom: 15px;
		box-shadow: 0px 1px 3px 2px rgba(167, 192, 202, 0.25);
		::v-deep .el-collapse-item__content{
			padding-bottom: 4px;
		}
		.on_call_title {
			font-weight: bold;
			margin: 10px 0 15px;
		}
		.on_call_info {
			background: #0d0c0c;
			margin: 0 5px;
			padding: 12px 8px;
			border-radius: 8px;
			display: flex;
			color: #fff;
			.user_info {
				width: 90px;
				flex: 0 0 auto; 
				.avatar {
					display: flex;
					justify-content: center;
				}
				.name {
					line-height: 20px;
					font-size: 14px;
					white-space: nowrap;
					text-align: center;
					margin-top: 8px;
					.t_num {
						margin-top: 5px;
						font-size: 12px;
					}
				}
			}
		  .user_info_margin-right{
					margin-right: 12px;
			}
			.call_info {
				.call_time {
					color: #4db1ec;
				}
			}
		}
		.operator_call_info {
			margin-top:8px;
			justify-content: space-between;
			.call_info {
				margin-left:10px;
			}
		}
		.on_call_btns {
			display: flex;
			align-items: center;
			justify-content: space-around;
			flex-wrap: wrap;
			padding-bottom: 10px;
			.call_btn {
				width: 20%;
				padding-bottom: 18%;
				border-radius: 8px;
				background: #0d0c0c;
				position: relative;
				color: #fff;
				margin: 8px 2% 0;
				overflow: hidden;
				&.cancel {
					background: #c80000;
					.btn_item {
						&:active {
							background: #ca2b2b;
							outline: none;
						}
						&:hover{
							background: rgb(200, 0, 0,0.7);
							outline: none;		
						}
						.icon {
							transform: rotateZ(135deg);
							position: relative;
							top: 5px;
							[class*="fa-"] {
								font-size: 20px !important;
							}
						}
					}
				}
				&.green_background {
					background: #34a84f;
					.btn_item {
						&:active {
							background: rgb(52, 168, 79);
							outline: none;
						}
						&:hover{
							background:rgba(52, 168, 79,0.7)
						}
						&.disabled {
						background-color: rgb(52, 168, 79,0.7);
						pointer-events: none;
					}
					}
				}
				.btn_item {
					user-select: none;
					-moz-user-select: none;
					-webkit-user-select: none;
					cursor: pointer;
					position: absolute;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-flow: column;
					.icon {
						margin-bottom: 4px;
						font-size: 20px;
						line-height: 20px;
						display: flex;
						[class*="fa-"] {
							font-size: 20px;
							width: auto;
						}
					}
					.button-label{
						font-size: 10px;
					}
					p {
						font-size: 13px;
					}
					&.disabled {
						background-color: rgb(13,12,12,0.7);
						pointer-events: none;
					}
				}
				&:active,
				&:hover {
					background: rgb(13, 12, 12, 0.7);;
					outline: none;
				}
				&.disabled {
					cursor:not-allowed;
					opacity: 0.75;
				}
				&.ac {
					outline: none;
				}
			}
		}
	}

	.monitoring-ended-box {
		.monitoring-ended-title {
			padding: 12px 10px;
			font-weight: bold;
			white-space: nowrap;
		}
	}
	.buddies_list {
		&.cl {
			min-height: 100px;
		}
		::v-deep .el-tabs__item {
			padding: 0 10px;
		}
	}

	::v-deep .el-tab-pane {
		// height: calc(100% - 45px);
		// overflow-y: auto;
	}
	.input-search{
		margin-top:8px;
	}
}
</style>
